"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.releaseNotificationGlossary = void 0;
const enums_1 = require("../enums");
exports.releaseNotificationGlossary = {
    latestVersion: 1,
    1: {
        pushHeadings: ({ version }) => ({
            [enums_1.NotificationLanguagesEnum.en]: `New release ${version} is available`,
            [enums_1.NotificationLanguagesEnum.it]: `Nuova versione ${version} disponibile`,
        }),
        pushContents: ({ version }) => ({
            [enums_1.NotificationLanguagesEnum.en]: `New release ${version} is available`,
            [enums_1.NotificationLanguagesEnum.it]: `Nuova versione ${version} disponibile`,
        }),
        telegramBody: ({ version }) => ({
            [enums_1.NotificationLanguagesEnum.en]: `New release ${version} is available`,
            [enums_1.NotificationLanguagesEnum.it]: `Nuova versione ${version} disponibile`,
        }),
    },
};
